__turbopack_context__.v({
  "component": "style-module-scss-module__iqqEiW__component",
  "description": "style-module-scss-module__iqqEiW__description",
  "green": "style-module-scss-module__iqqEiW__green",
  "grey": "style-module-scss-module__iqqEiW__grey",
  "red": "style-module-scss-module__iqqEiW__red",
  "score": "style-module-scss-module__iqqEiW__score",
  "stat": "style-module-scss-module__iqqEiW__stat",
  "yellow": "style-module-scss-module__iqqEiW__yellow",
});
